<template>
	<div v-if="loaded">
		<header class="page-title">
			<h2>{{ providerType.translations['en'].name }}</h2>
			<div class="ml-auto">
				<a @click="updateProviderType" class="btn btn-md btn-success" href="#"><i class="fas fa-save"></i> Save Changes</a>
			</div>
		</header>
		<div class="flex box start">
			<div class="six-lg">
				<div class="card">
					<header class="card-header language-list">
						<nav class="language-list">
							<lang-selector></lang-selector>
						</nav>
					</header>
					<div class="card-body">
						<div class="form-group">
							<label for="name">Name</label>
							<input id="name" type="text" v-model="providerType[clickedLang].name">
							<p class="input-error" v-if="errors.errors.name">{{ errors.errors.name }}</p>
						</div>
					</div>
				</div>
				<div class="card" v-if="!userRoles.includes('users.translator')">
					<header class="card-header">
						<h3 class="card-title">General</h3>
					</header>
					<div class="card-body">
						<div class="form-group">
							<label for="slug">Slug</label>
							<input id="slug" type="text" v-model="providerType.slug">
							<p class="input-error" v-if="errors.errors.slug">{{ errors.errors.slug }}</p>
						</div>
					</div>
				</div>
			</div>
			<div class="card six-lg" v-if="!userRoles.includes('users.translator')">
				<header class="card-header">
					<h3 class="card-title">Default alternative providers</h3>
				</header>
				<div class="card-body">
					<div class="form-group">
						<label for="alt_provider1">Provider 1</label>
						<select id="alt_provider1" name="alt_provider1" v-model="providerType.alternatives[0]">
							<option selected v-if="providerType.alternatives[0] === 0" value="0">Select a provider</option>
							<option :value="provider.id" v-for="provider in allProviders">{{provider.name}}</option>
						</select>
						<p class="input-error" v-if="errors.errors.alternatives0">{{ errors.errors.alternatives0 }}</p>
					</div>
					<div class="form-group">
						<label for="alt_provider2">Provider 2</label>
						<select id="alt_provider2" name="alt_provider2" v-model="providerType.alternatives[1]">
							<option selected v-if="providerType.alternatives[1] === 0" value="0">Select a provider</option>
							<option :value="provider.id" v-for="provider in allProviders">{{provider.name}}</option>
						</select>
						<p class="input-error" v-if="errors.errors.alternatives1">{{ errors.errors.alternatives1 }}</p>
					</div>
					<div class="form-group">
						<label for="alt_provider3">Provider 3</label>
						<select id="alt_provider3" name="alt_provider3" v-model="providerType.alternatives[2]">
							<option selected v-if="providerType.alternatives[2] === 0" value="0">Select a provider</option>
							<option :value="provider.id" v-for="provider in allProviders">{{provider.name}}</option>
						</select>
						<p class="input-error" v-if="errors.errors.alternatives2">{{ errors.errors.alternatives2 }}</p>
					</div>
					<div class="form-group">
						<label for="alt_provider4">Provider 4</label>
						<select id="alt_provider4" name="alt_provider4" v-model="providerType.alternatives[3]">
							<option selected v-if="providerType.alternatives[3] === 0" value="0">Select a provider</option>
							<option :value="provider.id" v-for="provider in allProviders">{{provider.name}}</option>
						</select>
						<p class="input-error" v-if="errors.errors.alternatives3">{{ errors.errors.alternatives3 }}</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Errors from '../../../Utils/Errors.js';
	import {eventBus} from '../../../app';
	import VueSelect from '../../../../../node_modules/vue-select';

	export default {
		components: {
			VueSelect
		},
		props: {
			dataProviderTypeId: {
				type: Number
			}
		},
		data() {
			return {
				providerTypeId: this.dataProviderTypeId,
				tabName: 'providerTypeSettings',
				loaded: false,

				providerType: {},
				allProviders: {},

				clickedLang: this.$defaultLanguage.locale,
				userRoles: this.$currentUserRoles,

				errors: new Errors(),
			}
		},
		mounted() {
			let vm = this;
			this.fetchDataFromApi();
			// When setActiveStatus method ran, change selected data in form fields
			/* From LangSelector */
			eventBus.$on('setActiveStatus', function (clickedLang) {
				vm.clickedLang = clickedLang;
			});
			eventBus.$on('pushActiveStatus', function (clickedLang) {
				vm.clickedLang = clickedLang;
			});
		},
		methods: {
			fetchDataFromApi: function () {
				let vm = this;
				eventBus.$emit('onLoaderStart');
				axios.post('/api/' + vm.$selectedSite.slug + '/providertype/fetchtabdata/' + vm.providerTypeId, {
					tab: vm.tabName
				})
						.then(response => {
							if (response.data.hasOwnProperty('data')) {
								if (response.data.data.hasOwnProperty('providerType')) {
									vm.providerType = response.data.data.providerType;
								}
								if (response.data.data.hasOwnProperty('allProviders')) {
									vm.allProviders = response.data.data.allProviders;
								}
								vm.initLanguages();
							}
							vm.loaded = true;
							eventBus.$emit('onLoaderFinish');
						})
						.catch(e => {
							vm.$toastr.error('Api ' + vm.tabName + ' tab load failed', 'Error');
							eventBus.$emit('onLoaderFinish');
						});
			},
			initLanguages: function () {
				for (let i = 0; i < this.$availableLanguages.length; i++) {
					this.providerType[this.$availableLanguages[i].locale] = {
						name: this.providerType.translations[this.$availableLanguages[i].locale] ? this.providerType.translations[this.$availableLanguages[i].locale].name : ''
					}
				}
				this.loaded = true;
			},
			updateProviderType: function () {
				let vm = this;
				let originData = _.cloneDeep(vm.providerType);
				vm.errors.clear();
				eventBus.$emit('onLoaderStart');
				//Ezt itt azért kell így csinálni, mert ha a vm.data-ból törlöm ki akkor mentés után nem fognak menni a fordítások
				for (let i = 0; i < this.$availableLanguages.length; i++) {
					if (originData[this.$availableLanguages[i].locale] &&
							originData[this.$availableLanguages[i].locale].name === '' || originData[this.$availableLanguages[i].locale].name === null) {
						delete (originData[this.$availableLanguages[i].locale]);
					}
				}
				axios.put('/api/' + vm.$selectedSite.slug + '/provider-types/' + vm.providerType.id, originData)
						.then(response => {
							this.$toastr.success('Provider Type updated successfully.');
							eventBus.$emit('onLoaderFinish');
						})
						.catch(e => {
							this.errors.record(e.response.data);
							this.$toastr.error('Save Provider Type failed.', 'Error');
							eventBus.$emit('onLoaderFinish');
						});
			}
		}
	}
</script>

<style scoped>

</style>
